import { Controller } from "@hotwired/stimulus"
import { configureRemoteSearch } from "../../shared/multi_select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.select = this.element.matches("select") ? this.element : this.element.querySelector("select")
    this.selectValueChanged = this.selectValueChanged.bind(this)
    this.select.addEventListener("change", this.selectValueChanged)
    this.cleanupRemoteSearch = configureRemoteSearch(this.select, {
      url: this.urlValue,
      resultsKey: "pm_project_items",
      valueField: "project_item_code",
      labelField: "project_item_name"
    })
  }

  disconnect() {
    this.cleanupRemoteSearch?.()
    this.select?.removeEventListener("change", this.selectValueChanged)
  }

  selectValueChanged(event) {
    $.ajax({
      type: "GET",
      dataType: "script",
      url: "/ui/project_item_code_select/project_detail.js",
      data: { project_item_code: event.target.value }
    })
  }
}
